import React from 'react';
import {useTenant} from '@/shared/hooks/useTenant';

interface ThemedLogoProps {
    className?: string;
    onClick?: () => void;
}

export function ThemedLogo({className = '', onClick}: ThemedLogoProps) {
    const {theme, organization} = useTenant();

    if (!theme || !organization) {
        // Return a default placeholder while loading
        return (
            <div
                className={`bg-gray-200 animate-pulse rounded ${className}`}
                style={{width: '150px', height: '40px'}}
            />
        );
    }

    return (
        <img
            src={theme.logo_url}
            alt={`${organization.display_name} logo`}
            className={`themed-logo ${className}`}
            onClick={onClick}
            style={{cursor: onClick ? 'pointer' : 'default'}}
        />
    );
}
